import {combineReducers} from 'redux';
import config from 'redux/reducers/config';
import colors from 'redux/reducers/colors';
import dominoes from 'redux/reducers/dominoes';
import groupes from 'redux/reducers/groupes';
import settings from 'redux/reducers/settings';
import session from 'redux/reducers/session';

export default combineReducers({
	config,
	colors,
	dominoes,
	groupes,
	settings,
	session
});
